<template lang="pug">
  div.external-container
    md-card(
      :id="value.dialog_node"
      class="node-content drag-trigger node-card-class"
      :class="isParent ? '' : 'before-parent'"
      style="cursor: pointer; position: relative; background: #D9D9D9;"
      )
        v-row(no-gutters).card-selected
          v-col.icon-column(cols="1")
            v-icon(color="#fff" v-if="value.children && value.children.length > 0") mdi-chevron-down
            v-icon(color="#fff" v-else) mdi-minus
          v-col(cols="11").data-content
            b {{ value.title }}
            div(v-if="(value.children && value.children.length > 0) || viewingMode")
              p(v-html="text")
            div(v-else)
              TextEditor.text-editor(ref="texEditor" :value="text" @change="updateText($event)" v-if="!viewingMode")
    div(v-if="value.children && value.children.length > 0")
      Tree(v-for="(child, index) in value.children" :key="index" :value="child" @change="updateTextProp($event)"
        :is-parent="false" :viewingMode="viewingMode")

</template>

<script>
import TextEditor from '@/components/TextEditor.vue'

export default {
  name: 'Tree',
  components: { TextEditor },
  props: {
    isParent: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      required: true
    },
    viewingMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    text: {
      get () {
        return this.value?.output?.generic?.[0]?.values?.[0]?.text ?? ''
      },
      set (value) {
        this.$emit('change', value)
      }
    }
  },
  methods: {
    updateText (data) {
      this.text = data
    },
    updateTextProp (data) {
      this.$emit('change', data)
    }
  }
}
</script>

<style scoped>
.icon-column {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #55AE59;
  width: 70px;
}

.external-container:not(>.external-container)::before {
  content: '';
  display: none;
}

.external-container .external-container {
  margin-left: 31px;
}

.data-content{
  padding: 0 10px !important;
  p {
    overflow-wrap: break-word;
  }
}

.text-editor {
  padding-bottom: 16px;
}

.node-card-class.md-card {
  margin: 6px 0;
}
.before-parent:before {
  content: '';
  display: block;
  border-bottom: 2px solid #8d8d8d;
  border-left: 2px solid #8d8d8d;
  border-bottom-left-radius: 25px;
  width: 22px;
  min-height: 40px;
  left: -22px;
  top: -6px;
  padding: 0;
  position: absolute;
}
.tree-branch {
  position: relative;
}
.tree-node {
  position: relative;
}
.button-expand {
  color: white;
  border-radius: 6px 0 0 6px;
  padding: 15px 20px !important;
  background: linear-gradient(60deg, #66bb6a, #43a047);
  border: none;
  cursor: pointer;
  height: 100%;
  width: 100%;
  vertical-align: middle;
  text-align: center;
}
#expand-button-id > .md-icon.md-theme-default.md-icon-font {
  color: white !important;
}
.expanded {
  transform: rotate(90deg) !important;
  transition: 0.2s !important;
}
.not-expanded {
  transform: rotate(0deg) !important;
  transition: 0.2s !important;
}
.card-selected {
  border-radius: 7px;
  min-height: 70px;
  border: 0;
}
.my-tree-view1 {
  position: relative;
}
.my-tree-view1 .mls {
  margin-left: 5px;
}
.my-tree-view1 .mrs {
  margin-right: 5px;
}
.my-tree-view1 .tree-node {
  padding: 0;
  border: none;
}
.my-tree-view1 .node-content {
  display: flex;
}
.my-tree-view1 .node-content .fold-btn {
  display: flex;
  justify-content: center;
  width: 22px;
  border-radius: 100%;
  border: none;
  background: #fcf1a8;
}
.my-tree-view1 .tree-node-back {
  width: 700px;
}
.my-tree-view1 .tree-node-back:hover {
  background: #f5f5f5;
}
.my-tree-view1 .header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  padding-bottom: 5px;
  margin-bottom: 10px;
}
.my-tree-view1 .footer {
  border-top: 1px solid #ccc;
  margin-top: 10px;
}
.disable-click {
  pointer-events: none;
}
.displayNone {
  display: none !important;
}
.text-editor {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
#jumpChip > .v-chip__content {
  max-width: 220px !important;
  overflow: hidden !important;
  display: block !important;
  text-overflow: ellipsis !important;
  height: 80% !important;
}
</style>
